import { useTranslation } from "react-i18next";

import Tooltip from "@mui/material/Tooltip";
import { Box } from "@mui/material";

import { StyledToggleButton, ToggleButtonGroup } from "@plannel/components/ui/ToggleButton";
import codeUtil from "@plannel/pages/utils/code-util";

const { DAY, WEEK, MONTH, QUARTER, YEAR } = codeUtil.buckets;

// 시간 버킷 토글(D/W/M/Q/Y). base StyledToggleButton 위에서 조립한다.
const BucketToggleButton = ({ value, onChange, buckets, ...other }) => {
  const { t } = useTranslation();
  const bucketInfos = {
    [DAY]: { name: "day", label: "D" },
    [WEEK]: { name: "week", label: "W" },
    [MONTH]: { name: "month", label: "M" },
    [QUARTER]: { name: "quarter", label: "Q" },
    [YEAR]: { name: "year", label: "Y" },
  };

  return (
    <ToggleButtonGroup
      size="small"
      value={codeUtil.isWeekBucket(value) ? codeUtil.buckets.WEEK : value}
      sx={{ mr: 1 }}
      exclusive
      onChange={onChange}
      {...other}
    >
      {
        buckets.map(bucket => {
          if (Object.prototype.hasOwnProperty.call(bucketInfos, bucket)) {
            const currentBucketInfo = bucketInfos[bucket];

            return (
              <StyledToggleButton key={bucket} value={bucket}>
                <Tooltip title={t(currentBucketInfo.name)}>
                  <Box component={"span"}>{currentBucketInfo.label}</Box>
                </Tooltip>
              </StyledToggleButton>
            );
          }
          return "";
        })
      }
    </ToggleButtonGroup>
  );
}

export default BucketToggleButton;
